import { InviteStatus } from '@/types/api/invite';
import { CircleX } from 'lucide-react';
import { inviteInvalidMessage } from '../utils/invite-invalid';

export function InviteInvalid({ status }: { status: InviteStatus }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4" role="alert">
      <CircleX className="text-red-500 size-16" />
      <h2 className="text-lg font-semibold">{inviteInvalidMessage(status)}</h2>
      <p>Be personen som bjöd in dig om en ny länk.</p>
    </div>
  );
}
